import { render, staticRenderFns } from "./GetDemo.vue?vue&type=template&id=06e1a4dc&scoped=true"
import script from "./GetDemo.vue?vue&type=script&lang=ts"
export * from "./GetDemo.vue?vue&type=script&lang=ts"
import style0 from "./GetDemo.vue?vue&type=style&index=0&id=06e1a4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1a4dc",
  null
  
)

export default component.exports